module.exports = __webpack_public_path__ + "static/img/ms.1b5dadf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ms.png
// module id = Sxj9
// module chunks = 0